import { useEffect, useState } from "react";
import { getDestinations } from "../api";
import { useI18n, useL } from "../i18n";
import CurrencyConverter from "./CurrencyConverter";
import MonetizationAd from "./MonetizationAd";
import { DollarSign } from "lucide-react";

export default function PricesHub() {
  const { t, lang } = useI18n();
  const L = useL();
  const [dests, setDests] = useState([]);

  useEffect(() => {
    getDestinations({}).then(setDests);
  }, []);

  const sorted = [...dests].sort((a, b) => a.avg_daily_cost_usd - b.avg_daily_cost_usd);
  const min = sorted[0]?.avg_daily_cost_usd || 0;
  const max = sorted[sorted.length - 1]?.avg_daily_cost_usd || 0;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12" data-testid="prices-hub">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-[#C85A32] font-semibold">{t("nav_prices")}</div>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl text-[#1C1917]">{t("prices_hub")}</h1>
        <p className="mt-2 text-[#57534E] max-w-2xl">
          {L({
            ar: "متوسط الإنفاق اليومي المتوقع للمسافر في كل مدينة، شامل الفندق المتوسط والوجبات والمواصلات الأساسية.",
            en: "Expected daily average spend per traveler in each city — including mid-range hotel, meals and basic transport.",
            fr: "Dépense quotidienne moyenne prévue par voyageur dans chaque ville — hôtel moyen, repas et transport de base inclus."
          })}
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-3">
          {sorted.map((d) => {
            const pct = max === min ? 100 : ((d.avg_daily_cost_usd - min) / (max - min)) * 90 + 10;
            return (
              <div
                key={d.id}
                className="rounded-2xl bg-white border border-[#E6DED3] p-4 flex items-center gap-4"
                data-testid={`price-row-${d.id}`}
              >
                <img src={d.image_url} alt="" className="h-14 w-14 rounded-xl object-cover shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-baseline gap-2">
                    <div className="font-display text-base text-[#1C1917] truncate">
                      {lang === "ar" ? d.city_ar : d.city_en}
                    </div>
                    <div className="font-display text-lg text-[#1C1917] flex items-baseline gap-0.5 shrink-0">
                      <DollarSign className="h-3 w-3 text-[#C85A32]" />
                      {d.avg_daily_cost_usd}
                      <span className="text-[10px] text-[#78716C] ms-1 font-normal">/ {t("per_day")}</span>
                    </div>
                  </div>
                  <div className="mt-2 h-1.5 bg-[#F3EDE4] rounded-full overflow-hidden">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-[#D97706] to-[#C85A32]"
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <aside className="lg:col-span-1 space-y-6">
          <CurrencyConverter />
          <MonetizationAd variant="banner" />
        </aside>
      </div>
    </div>
  );
}
